import React from 'react';
import PaginationButtons from './components/pagination-buttons';
import PaginationButton from './components/pagination-button';
import { MAX_COUNT_OF_VISIBLE_PAGINATION_BUTTONS } from './constants';

const Pagination = ({ count, itemsPerPage, currentPage, disabled = false, onChange }) => {
  const pagesCount = Math.ceil(count / itemsPerPage);

  const pages = Array.from({ length: pagesCount }, (_, index) => index + 1);

  const prevPage = () => onChange(currentPage - 1);
  const nextPage = () => onChange(currentPage + 1);
  const setPage = (pageNum) => pageNum !== currentPage && onChange(pageNum);

  return (
    <div className="ws-ui-pagination">
      <PaginationButton
        iconGlyph="back"
        disabled={currentPage === 1 || disabled}
        onClick={prevPage}
      />
      {pagesCount <= MAX_COUNT_OF_VISIBLE_PAGINATION_BUTTONS ? (
        <div className="ws-ui-pagination__items">
          {pages.map((page) => (
            <PaginationButton
              key={page}
              label={String(page)}
              selected={page === currentPage}
              disabled={disabled}
              onClick={() => setPage(page)}
            />
          ))}
        </div>
      ) : (
        <div className="ws-ui-pagination__items">
          <PaginationButtons
            pages={pages}
            currentPage={currentPage}
            disabled={disabled}
            setPage={setPage}
          />
        </div>
      )}
      <PaginationButton
        iconGlyph="next"
        disabled={currentPage === pagesCount || disabled}
        onClick={nextPage}
      />
    </div>
  );
};

export default Pagination;
